export default "__VITE_PUBLIC_ASSET__ca98b06b__"